import { BookOpenText } from "@phosphor-icons/react";
import { TPT_STORE_URL, AMAZON_STORE_URL } from "@/data/storeLinks";

const COLUMNS = [
  {
    title: "Explore",
    links: [
      { label: "Kids Corner", href: "/kids-corner", id: "kids" },
      { label: "Word Play App", href: "/kids-vocab", id: "vocab" },
      { label: "Parent & Teacher Resources", href: "/resources", id: "resources" },
      { label: "Show, Don't Tell Collection", href: "/resources#show-dont-tell", id: "sdt" },
      { label: "Free Learning Tools", href: "/#free-tools", id: "free" },
    ],
  },
  {
    title: "Shop",
    links: [
      { label: "TpT Store", href: TPT_STORE_URL, id: "tpt", external: true },
      { label: "Amazon Paperbacks", href: "/resources#amazon", id: "amazon" },
      { label: "Amazon Author Page", href: AMAZON_STORE_URL, id: "amazon-author", external: true },
      { label: "Course (Coming Soon)", href: "/#course", id: "course" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Ann", href: "/#about", id: "about" },
      { label: "Contact", href: "/contact", id: "contact" },
      { label: "Privacy Policy", href: "/privacy", id: "privacy" },
      { label: "Children's Privacy", href: "/childrens-privacy", id: "childrens-privacy" },
      { label: "Terms of Use", href: "/terms", id: "terms" },
      { label: "Refund Policy", href: "/refund-policy", id: "refund" },
    ],
  },
];

export const SiteFooter = () => (
  <footer className="bg-[#0f285f] text-white py-12 px-4" data-testid="site-footer">
    <div className="max-w-7xl mx-auto grid md:grid-cols-5 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2 mb-3">
          <BookOpenText size={30} weight="duotone" className="text-[#178478]" />
          <span className="font-nunito font-extrabold tracking-tight text-xl">Embrace the Magic of Words</span>
        </div>
        <p className="font-nunito text-sm text-white/70 leading-relaxed max-w-sm">
          Vocabulary, writing, and learning games for K–5 children — with structured printables and paperback workbooks for
          the parents, teachers, SPED and ESL/ELL specialists who support them.
        </p>
      </div>
      {COLUMNS.map((c) => (
        <nav key={c.title} aria-label={`Footer ${c.title}`}>
          <h3 className="font-nunito font-extrabold tracking-tight text-base mb-3 text-white/90">{c.title}</h3>
          <ul className="space-y-2">
            {c.links.map((l) => (
              <li key={l.id}>
                <a
                  href={l.href}
                  target={l.external ? "_blank" : undefined}
                  rel={l.external ? "noopener noreferrer" : undefined}
                  className="font-nunito text-sm text-white/70 hover:text-white transition-colors"
                  data-testid={`footer-${l.id}-link`}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      ))}
    </div>
    <div className="max-w-7xl mx-auto border-t border-white/20 mt-10 pt-6 flex flex-col sm:flex-row justify-between gap-2">
      <p className="font-nunito text-xs text-white/60">© 2026 Embrace the Magic of Words. All rights reserved.</p>
      <p className="font-nunito text-xs text-white/60">Made by a mom, for diverse learners. 💙</p>
    </div>
  </footer>
);
